import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

export interface StatusPageState {
    closedIncidents: {
        key: string,
        closedAt: string
    }[]
}

const initialState: StatusPageState = { closedIncidents: [] };

export const statusPageSlice = createSlice({
    name: "statuspage",
    initialState,
    reducers: {
        increaseIncident: (state, action: PayloadAction<{ id: string, status: string }>) => {
            state.closedIncidents ??= [];
            state.closedIncidents.push({
                key: `${action.payload.id}|${action.payload.status}`,
                closedAt: new Date().toISOString()
            });
        },
        clearOldIncidents: (state) => {
            state.closedIncidents = state.closedIncidents
                .filter(item => moment(item.closedAt).isAfter(moment().subtract(10, 'minute')));
        }
    },
});

export const { increaseIncident, clearOldIncidents } = statusPageSlice.actions;
export default statusPageSlice.reducer;
